import { ArrivalTimeOptionType } from '../components/AvailabilityForm/AvailabilityForm';
import { isOverlapping } from './isTimeslotOverlapping';

export const hasStaffAndRoomAvailability = (
  timeslot: ArrivalTimeOptionType,
  selectedTimeslotsWithStaffAndRoomAllocation: string[],
  guestIndex: number
) => {
  if (timeslot.type === 'spa-facilities') return true;

  const { staff: staffOriginal, rooms: roomsOriginal, optionId: tsOptionId } = timeslot;
  // Only Core treatments track staff and rooms; other providers omit them.
  if (staffOriginal == null && roomsOriginal == null) return true;

  const staff = [...(staffOriginal || [])];
  const rooms = [...(roomsOriginal || [])];
  selectedTimeslotsWithStaffAndRoomAllocation.forEach((key) => {
    const [gI, dayIndex, , optionId, startTime, endTime, staffId, roomId] = key.split('-');

    if (!(String(tsOptionId) === optionId && String(guestIndex) === gI)) {
      const indexStaff = staff?.findIndex((s) => s === staffId);
      const indexRoom = rooms?.findIndex((r) => r === roomId);
      const overlapsWithTimeslot = isOverlapping(timeslot, {
        startTime,
        endTime,
        dayNumber: Number(dayIndex),
        visitDate: timeslot.visitDate,
      });

      //remove unavailable staff and rooms from the timeslot
      if (indexStaff !== undefined && indexStaff !== -1 && overlapsWithTimeslot) {
        staff?.splice(indexStaff, 1);
      }
      if (indexRoom !== undefined && indexRoom !== -1 && overlapsWithTimeslot) {
        rooms?.splice(indexRoom, 1);
      }
    }
  });

  return staff.length !== 0 && rooms.length !== 0;
};
